import 'init/application'
import { UniversalLinks } from '../universal_links/universal_links'
import { SendToPhone } from '../universal_links/components/send_to_phone'
import { RedeemReferral } from '../universal_links/redeemReferral'
import '../universal_links/styles'

const universalLinksElement = document.querySelector('.js-ul-fallback')
if (universalLinksElement) {
  new UniversalLinks(universalLinksElement)
}

const sendToPhoneElement = document.querySelector('.js-send-to-phone')
if (sendToPhoneElement) {
  new SendToPhone(sendToPhoneElement)
}

const redeemReferralElement = document.querySelector('#universal_links-redeem_referral')
if (redeemReferralElement) {
  new RedeemReferral(redeemReferralElement)
}
